import { Navigate, Outlet } from "react-router-dom";
import { LoadingScreen } from "../components/common/LoadingScreen";
import { useFeatureFlag } from "../hooks/useFeatureFlag";
import { useAuthStore } from "../stores/auth.store";
import { useUserStore } from "../stores/user.store";

interface ExperimentalRouteProps {
  feature: string;
}

/**
 * Route guard that protects experimental features
 * Redirects to home page if the user doesn't have the specified feature flag enabled
 */
export const ExperimentalRoute = ({ feature }: ExperimentalRouteProps) => {
  const hasFeature = useFeatureFlag(feature);
  const { authUser } = useAuthStore();
  const { isLoading, profile } = useUserStore();

  if (authUser && !profile && isLoading) {
    return <LoadingScreen />;
  }

  if (!hasFeature) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
